import { render } from "./WaitStudents.vue?vue&type=template&id=f08518ac&scoped=true"
import script from "./WaitStudents.vue?vue&type=script&lang=js"
export * from "./WaitStudents.vue?vue&type=script&lang=js"

import "./WaitStudents.vue?vue&type=style&index=0&id=f08518ac&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08518ac"]])

export default __exports__